import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import * as _ from "../../../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../../../wayin-react";
import { icons } from "../../../../../enums";
import { SingleSelect } from "../../../../core/dropdown";
import { PrivateInput as Input } from "../../../../core/input";
import Icon from "../../../../core/icon";
import { isValidURL, isURL } from "../../../../../util/validate";
var SharingLink = createComponent({
  displayName: 'SharingLink',
  propTypes: {
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired
  },
  defaultProps: {
    value: '',
    label: ''
  },
  lifecycles: {
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      var setDropdownOptions = nextProps.setDropdownOptions;

      if (nextProps.options !== this.props.options) {
        setDropdownOptions(nextProps.options);
      } // this will make sure the input is visible and the url value is set correctly if the data provided to the component is updated


      if (nextProps.value !== this.props.value) {
        if (isURL(nextProps.value)) {
          this.props.setInputValue(nextProps.value);
          this.props.showInput();
          this.props.setIsURLInvalid(false);
        }
      }
    }
  },
  handlers: {
    handleOnBlur: function handleOnBlur(p) {
      return function (e) {
        var value = e.target.value;
        p.setIsURLInvalid(!isValidURL(value) && value !== '');
      };
    },
    handleChange: function handleChange(p) {
      return function (e, _ref) {
        var value = _ref.value,
            id = _ref.id;

        if (value === 'url') {
          p.showInput();
        }

        p.closeDropdown();
        p.setInputValue('http://');
        p.setIsURLInvalid(false);
        p.onChange(e, {
          value: value,
          id: id
        });
      };
    },
    handleInputChange: function handleInputChange(p) {
      return function (e, _ref2) {
        var value = _ref2.value,
            id = _ref2.id;
        p.setInputValue(value);

        if (isURL(value)) {
          p.setIsURLInvalid(false);
        }

        p.onChange(e, {
          value: value,
          id: id
        });
      };
    },
    handleEnter: function handleEnter(p) {
      return function (e) {
        if (e.key === 'Enter') {
          addURL(p);
        }
      };
    },
    handleInputIconClick: function handleInputIconClick(p) {
      return function (e, props) {
        if (isURL(p.inputValue)) {
          addURL(p);
        } else {
          p.hideInput();
        }

        p.openDropdown();
      };
    }
  },
  state: {
    isURLInvalid: {
      value: function value(p) {
        return isURL(p.value) && !isValidURL(p.value);
      },
      updater: 'setIsURLInvalid'
    },
    inputValue: {
      value: function value(p) {
        return p.value;
      },
      updater: 'setInputValue'
    },
    dropdownOptions: {
      value: function value(p) {
        return p.options;
      },
      updater: 'setDropdownOptions'
    },
    isInputVisible: {
      value: function value(p) {
        return isURL(p.value);
      },
      updater: function updater(_updater) {
        return {
          showInput: function showInput() {
            return _updater(true);
          },
          hideInput: function hideInput() {
            return _updater(false);
          }
        };
      }
    },
    isDropdownOpen: {
      value: false,
      updater: function updater(_updater2) {
        return {
          openDropdown: function openDropdown() {
            return _updater2(true);
          },
          closeDropdown: function closeDropdown() {
            return _updater2(false);
          }
        };
      }
    }
  },
  render: function render(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "ck-cta-dropdown"
    }, props.isInputVisible ? /*#__PURE__*/React.createElement(Input, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: icons.DOWN,
        onClick: props.handleInputIconClick
      }),
      autoFocus: true,
      onChange: props.handleInputChange,
      onKeyPress: props.handleEnter,
      value: props.inputValue,
      hasError: props.isURLInvalid,
      id: props.id,
      onBlur: props.handleOnBlur
    }) : /*#__PURE__*/React.createElement(SingleSelect, {
      search: true,
      noResultsMessage: null,
      defaultOpen: props.isDropdownOpen,
      onClick: props.openDropdown,
      placeholder: 'Select share link destination',
      onChange: props.handleChange,
      options: props.dropdownOptions,
      value: props.value,
      text: props.isURLInvalid ? props.inputValue : undefined,
      hasError: props.isURLInvalid,
      id: props.id,
      showClearIcon: true
    }));
  }
});

var addURL = function addURL(p) {
  var url = p.value;
  var isValid = isValidURL(url);
  p.setIsURLInvalid(!isValid);

  if (isValid) {
    var exists = _findInstanceProperty(_).call(_, p.options, {
      value: url
    });

    if (!exists) {
      p.setDropdownOptions(function (options) {
        return _concatInstanceProperty(options).call(options, {
          text: url,
          value: url
        });
      });
    }

    p.setInputValue('');
    p.hideInput();
    p.onChange(undefined, {
      value: url,
      id: p.id
    });
  }
};

export default SharingLink;
//# sourceMappingURL=link.js.map